import store from "../../redux/store";
import * as actions from "./NotificationType";
import { handleAxiosGet, handleAxiosPost } from "../axiosHelper";

export const getNotificationList = async (paramValues) => {
  const endPoint = "/api/notifications/list";

  // Get userCode from localStorage and add to params
  const userCode = localStorage.getItem("userCode");
  const params = {
    ...paramValues,
    user: userCode || paramValues?.userCode, // Use localStorage userCode or fallback to provided
  };

  const { data: responseData } = await handleAxiosGet(endPoint, params);
  if (responseData) {
    store.dispatch({
      type: actions.SETNOTIFICATIONLIST,
      payload: responseData.Data,
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const updatePushNoptifications = async (id, payload) => {
  const url = `/api/notifications/update/${id}`;
  const contentType = "application/json";

  const { data: responseData } = await handleAxiosPost(
    url,
    contentType,
    payload
  );
  return responseData;
};

export const notificationSend = async (payload) => {
  const url = "/api/notifications/send";
  const contentType = "application/json";
  const data = payload;

  const { data: responseData } = await handleAxiosPost(url, contentType, data);

  if (responseData.result) {
    return responseData;
  } else {
    return responseData;
  }
};

export const notificationEmail = async (payload) => {
  const url = "/api/notifications/mail";
  const contentType = "application/json";
  const data = payload;

  const { data: responseData } = await handleAxiosPost(url, contentType, data);

  if (responseData.result) {
    return responseData;
  } else {
    return responseData;
  }
};

export const resetPasswordMail = async (payload) => {
  const url = "/api/notifications/forgotpassword";
  const contentType = "application/json";
  const data = payload;

  const { data: responseData } = await handleAxiosPost(url, contentType, data);
  if (responseData) {
    return responseData;
  } else {
    return responseData.result;
  }
};
